import React from 'react';

export default ({right}) => {
    return(
        <div className={`separator_bar d-flex w-100 ${right ? 'justify-content-end' : 'justify-content-start'}`}>
            <div className={'separator'}/>
        </div>
    )
}
